<template>
    <div>
        <div class="videoView">
            <video src="../../../assets/video/ctht.mp4" controls muted="true" poster="../../../assets/video/ctht-poster.jpg" />
        </div>
        <div class="link-content">
            <div class="toLanMao">
                <img src="../../../assets/images/shipin.jpg" /> <a href="javascript:void(0)" @click="back">返回</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "LanMaoVideo",
        methods: {
            back() {
                this.$emit('onIndexChanged',1);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .videoView {
        video {
            width: 80%;
            margin-left: 10%;
        }
        width: 100%;
    }
    .link-content {
        margin-top: 10%;
        margin-left: 10%;
        width: 80%;
        img {
            width: 50px;
            height: 50px;
        }
        a {
            font-size: 15px;
            color: #008000;
            text-decoration: none;
        }
    }
</style>